var uuidGenerator = require('../utils/uuid-generator.js');
var TYPES = require('./type-ids.js');

function StreamCallbackManager() {
  // private
  var datasetCallbacks = {};

  // public
  this.addTopicListener = function (datasetId, callback, callbackId) {
    if (!datasetCallbacks.hasOwnProperty(datasetId)) {
      datasetCallbacks[datasetId] = {};
    }

    datasetCallbacks[datasetId][callbackId] = {
      callback: callback,
      acknowledged: false
    };
  };

  this.removeTopicListener = function (callbackIdToRemove) {
    for (var dataset in datasetCallbacks) {
      var callbacks = datasetCallbacks[dataset];
      for (var callbackId in callbacks) {
        if (callbackId === callbackIdToRemove) {
          delete callbacks[callbackId];
        }

        if (Object.keys(callbacks).length === 0) {
          delete datasetCallbacks[dataset];
          return dataset;
        }
      }
    }
    return null;
  };

  this.removeTopic = function (dataset) {
    delete datasetCallbacks[dataset];
  };

  this.destory = function () {
    datasetCallbacks = {};
  };

  this.handle = function (dataset, message) {
    if (message.typeId === TYPES.SubscribeRealTimeDataResponse) {
      var clientRefId = message.clientRefId;
      if (datasetCallbacks[dataset][clientRefId]) {
        datasetCallbacks[dataset][clientRefId].acknowledged = true;
        datasetCallbacks[dataset][clientRefId].callback(message);
      }

    } else {
      var callbacks = datasetCallbacks[dataset];
      for (var id in callbacks) {
        if (callbacks[id].acknowledged) {
          callbacks[id].callback(message);
        }
      }
    }

  }
}

module.exports = new StreamCallbackManager();


// WEBPACK FOOTER //
// ./src-client-lib/api/stream-callback-manager.js